import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

const STORAGE_KEY = 'menuStep';
const DEFAULT_STEP = 'semplificata';

const MenuStepContext = createContext(null);

const getInitialStep = () => {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved || DEFAULT_STEP;
  } catch {
    return DEFAULT_STEP;
  }
};

export const MenuStepProvider = ({ children }) => {
  const [menuStep, setMenuStep] = useState(getInitialStep);

  const updateMenuStep = useCallback((newStep) => {
    try {
      localStorage.setItem(STORAGE_KEY, newStep);
      setMenuStep(newStep);
    } catch {}
  }, []);

  // Cross-tab sync: storage event only fires in other tabs
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === STORAGE_KEY && e.newValue != null) {
        setMenuStep(e.newValue);
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const value = { menuStep, updateMenuStep };

  return (
    <MenuStepContext.Provider value={value}>
      {children}
    </MenuStepContext.Provider>
  );
};

export const useMenuStepContext = () => {
  const ctx = useContext(MenuStepContext);
  if (!ctx) {
    throw new Error('useMenuStepContext must be used within MenuStepProvider');
  }
  return ctx;
};
